<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.INSTRUCTIONS' | translate }}
  </div>
  <ng-container *ngIf="loadingForm === false; else loading">
    <form [formGroup]="form">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.ACTIVITY_DETAILS' | translate }}</glxy-label>
        <textarea
          id="activity-detail"
          matInput
          [formControl]="form.controls.activity_detail"
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="8"
          placeholder="{{
            'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.ACTIVITY_DETAILS_PLACEHOLDER' | translate
          }}"
          [required]="true"
        ></textarea>
        <automata-automation-variable-menu
          matSuffix
          useGalaxyCompat="true"
          (variableSelected)="insertVariable('activity-detail', form.controls.activity_detail, $event)"
        ></automata-automation-variable-menu>
        <glxy-error *ngIf="form.controls.activity_detail.hasError('required')">
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.REQUIRED_FIELD' | translate }}
        </glxy-error>
      </glxy-form-field>
      <glxy-form-field [required]="true">
        <glxy-label>
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.HOTNESS_RATING.LABEL' | translate }}
        </glxy-label>
        <mat-select class="hotness-select" formControlName="hotness_rating" required="true">
          <mat-select-trigger *ngIf="selectedHotness$ | async as selectedHotness">
            {{ selectedHotness.label | translate }}
            <ng-container *ngFor="let flame of selectedHotness.flames">
              <mat-icon class="hotness-icon" svgIcon="hotness"></mat-icon>
            </ng-container>
          </mat-select-trigger>
          <mat-option *ngFor="let entry of hotnessOptions" [value]="entry[0]">
            {{ entry[1].label | translate }}
            <ng-container *ngFor="let flame of entry[1].flames">
              <mat-icon class="hotness-icon" style="margin: 0" svgIcon="hotness"></mat-icon>
            </ng-container>
          </mat-option>
        </mat-select>
        <glxy-error *ngIf="form.controls.hotness_rating.hasError('required')">
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.REQUIRED_FIELD' | translate }}
        </glxy-error>
      </glxy-form-field>
    </form>
  </ng-container>
</div>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
    <span class="control-container selector stencil-shimmer"></span>
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
